// assets/kit-shared.js
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // ----- URL params / page helpers -----
    const params = new URLSearchParams(window.location.search);
    const kitId =
      (params.get('kit_id') || params.get('kit-id') || '').trim();

    const cls  = document.body.classList;
    const path = window.location.pathname;
    const has  = (c) => cls.contains(c);
    const log  = (...a) => console.log('[KitFlow]', ...a);
    const warn = (...a) => console.warn('[KitFlow]', ...a);

    // ----- DOM helpers -----
    function showEl(el) {
      if (!el) return;
      el.hidden = false;
      el.style.display = '';
      el.classList?.remove('hidden', 'hide', 'is-hidden', 'dn', 'pointer-events-none', 'disabled', 'is-disabled');
      el.removeAttribute?.('aria-disabled');
      if ('disabled' in el) { try { el.disabled = false; } catch {} }
    }

    function setLinkAndShowEl(el, href) {
      if (!el) return;
      if (el.tagName === 'A') {
        el.setAttribute('href', href);
      } else {
        el.setAttribute('data-link', href);
        el.addEventListener('click', e => {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          e.preventDefault();
          window.location.assign(href);
        }, { once: true });
      }
      showEl(el);
    }

    function setLinkAndShow(selector, href) {
      const el = document.querySelector(selector);
      if (!el) { log('Selector not found:', selector); return; }
      setLinkAndShowEl(el, href);
    }

    function requireKitIdOrRedirect(fallback = '/start') {
      if (!kitId) {
        log('No kit id; redirecting →', fallback);
        window.location.assign(fallback);
        return false;
      }
      return true;
    }

    // Wait for any of the selectors; resolve with all matches (can be empty)
    function waitForAll(selectors, { tries = 20, interval = 150 } = {}) {
      return new Promise(resolve => {
        let attempt = 0;
        (function poll () {
          const found = [];
          selectors.forEach(sel => {
            document.querySelectorAll(sel).forEach(n => found.push(n));
          });
          if (found.length) return resolve(found);
          if (++attempt >= tries) return resolve([]);
          setTimeout(poll, interval);
        })();
      });
    }

    async function wireAll(selectors, href, label) {
      const nodes = await waitForAll(selectors);
      if (!nodes.length) {
        warn('Could not find elements for', label, 'selectors:', selectors);
        return;
      }
      nodes.forEach(n => setLinkAndShowEl(n, href));
      log(`Wired ${label} →`, href, `(count=${nodes.length})`);
    }

    // --- Helper: bind a kit form (validation + redirect with optional prefix routing)
    function bindKitForm(
      inputSelector,
      buttonSelector,
      {
        minLength = 8,
        // If you pass buildUrl, it wins. Otherwise we use prefixRoutes.
        buildUrl = null,
        // Case-insensitive prefix -> destination path (no query string).
        // Example: { 'JF-': '/pages/register-kit', 'VC-': '/pages/vasectomy-register-kit' }
        prefixRoutes = null,
        // If true and no prefix matches, show an error instead of redirecting.
        errorOnUnknownPrefix = false,
        onUnknownPrefixMsg = 'Unknown kit type. Use a code starting with JF- or VC-.',
        // Query param key to append with the entered value
        queryParam = 'kit_id',
        onInvalidMsg = 'Kit ID is invalid'
      } = {}
    ) {
      const input  = document.querySelector(inputSelector);
      const button = document.querySelector(buttonSelector);
      if (!input || !button) return;

      const toUpperSafe = (s) => (s || '').toUpperCase();
      const addQuery = (dest, key, val) =>
        `${dest}${dest.includes('?') ? '&' : '?'}${key}=${encodeURIComponent(val)}`;

      // returns string URL or null when unknown prefix and errorOnUnknownPrefix = true
      function computeUrl(valueRaw) {
        const value = (valueRaw || '').trim();
        const upper = value.toUpperCase(); // <-- force uppercase for redirects

        // If you ever use buildUrl, keep passing the raw (minimal change).
        // If you want buildUrl to also receive UPPERCASE, switch to: return buildUrl(upper);
        if (typeof buildUrl === 'function') return buildUrl(value);

        if (prefixRoutes && typeof prefixRoutes === 'object') {
          // Case-insensitive prefix match, but append UPPERCASE to the query string
          for (const [prefix, dest] of Object.entries(prefixRoutes)) {
            if (upper.startsWith(String(prefix).toUpperCase())) {
              return addQuery(dest, queryParam, upper); // <-- use upper in ?kit_id=
            }
          }
          if (errorOnUnknownPrefix) return null; // show error instead of redirect
          return null;
        }

        return null;
      }


      // clear previous validity on input
      input.addEventListener('input', () => input.setCustomValidity(''));

      // allow Enter key to trigger click
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); button.click(); }
      });

      // main click handler
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const value = (input.value || '').trim();

        // Reject too-short or bare prefixes (e.g., "JF-" or "VC-")
        let isBarePrefix = false;
        if (prefixRoutes && typeof prefixRoutes === 'object') {
          const upper = toUpperSafe(value);
          isBarePrefix = Object.keys(prefixRoutes).some((k) => upper === toUpperSafe(k));
        } else {
          isBarePrefix = toUpperSafe(value) === 'JF-';
        }

        const isValidLength = value.length >= minLength;

        if (!isValidLength || isBarePrefix) {
          input.setCustomValidity(onInvalidMsg);
          input.reportValidity();
          return;
        }

        const url = computeUrl(value);
        if (!url) {
          input.setCustomValidity(onUnknownPrefixMsg);
          input.reportValidity();
          return;
        }

        window.location.assign(url);
      });
    }


    // Expose for any other inline/debug use
    window.KitFlow = {
      kitId,
      requireKitIdOrRedirect,
      setLinkAndShow,
      setLinkAndShowEl,
      showEl,
      waitForAll,
      bindKitForm
    };

    // =========================
    // DUAL-BUTTON ROUTER
    // =========================
    (async () => {
      const routes = [
        {
          // Register hub page
          when: () =>
            has('template-page-register-kit') ||
            path === '/pages/register-kit',
          run: async () => {
            const link1 = `/pages/registration-health-assessment?kit_id=${encodeURIComponent(kitId)}`;
            const link2 = `/pages/collecting-your-sample?kit_id=${encodeURIComponent(kitId)}`;

            await wireAll(
              [
                '#Section1ListItem1Button1',
                '[id^="Section1ListItem1Button1"]',
                '[data-kit-role="register"]',
                '[id^="box1-btn-"]'
              ],
              link1,
              'Register button(s)'
            );

            await wireAll(
              [
                '#Section1ListItem2Button1',
                '[id^="Section1ListItem2Button1"]',
                '[data-kit-role="survey"]',
                '[id^="box2-btn-"]'
              ],
              link2,
              'Instructions/Survey button(s)'
            );
          }
        },
        {
          // Typeform health assessment JF path
          when: () =>
            has('template-page-typeform') ||
            path === '/pages/registration-health-assessment',
          run: async () => {
            const link1 = `https://nmdcbbyi49i.typeform.com/to/vSnagweN?kit_id=${encodeURIComponent(kitId)}`;
            const link2 = `https://nmdcbbyi49i.typeform.com/to/GiAPIg7X?kit_id=${encodeURIComponent(kitId)}`;

            await wireAll(['#Section1ListItem1Button1', '[data-kit-role="register"]', '[id^="box1-btn-"]'], link1, 'Typeform register');
            await wireAll(['#Section1ListItem2Button1', '[data-kit-role="survey"]',   '[id^="box2-btn-"]'], link2, 'Typeform survey');
          }
        },
        {
          // Register Vasectomy path
          when: () => path === '/pages/vasectomy-register-kit',
          run: async () => {
            const link1 = `https://nmdcbbyi49i.typeform.com/to/vSnagweN?kit_id=${encodeURIComponent(kitId)}`;
            const link2 = `/pages/vasectomy-step-1-completed?kit_id=${encodeURIComponent(kitId)}`;

            await wireAll(['#Section1ListItem1Button1', '[data-kit-role="register"]', '[id^="box1-btn-"]'], link1, 'Typeform register');
            await wireAll(['#Section1ListItem2Button1', '[data-kit-role="survey"]',   '[id^="box2-btn-"]'], link2, 'Typeform survey');
          }
        }
      ];

      let matched = false;
      for (const r of routes) {
        try {
          if (r.when()) { matched = true; await r.run(); break; }
        } catch (e) { console.error('[KitFlow] route error:', e); }
      }
      if (!matched) log('No dual-button route matched; skipping.');
    })();

    // =========================
    // FORM ROUTER (prefixRoutes: JF-/VC-)
    // =========================
    (function () {
      const matchesFormPage = (path === '/pages/identifier-page'); // change to your form page
      if (!matchesFormPage) return;

      bindKitForm('#kit-id-input', '#kit-submit-btn', {
        minLength: 8,
        queryParam: 'kit_id', // or 'kit-id' if that’s what your endpoint expects
        prefixRoutes: {
          'VC-': '/pages/vasectomy-register-kit',
          'JF-': '/pages/register-kit'
          // no "default" on purpose
        },
        errorOnUnknownPrefix: true,
        onInvalidMsg: 'Kit ID is invalid',
        onUnknownPrefixMsg: 'Unknown kit type. Use a code starting with JF- or VC-.'
      });


      log('Form binding initialized.');
    })();

    // =========================
    // SINGLE-BUTTON ROUTER (label-based)
    // =========================
    (async function () {
      // Attach a single capture handler once (use a flag to avoid duplicates on hot reload)
      if (!window.__kitFlowCaptureAttached) {
        window.addEventListener('click', function globalCaptureHandler(e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          const label = e.target.closest('span.button__label');
          const clickable = label ? label.closest('a,button,[role="button"]') : e.target.closest('[data-kit-flow-href],[data-kitflowhref]');
          const target = (label && label.closest('[data-kit-flow-href]')) || clickable;
          const url = target && (target.dataset.kitFlowHref || target.getAttribute('href'));
          if (url) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.location.assign(url);
          }
        }, { capture: true });
        window.__kitFlowCaptureAttached = true;
      }

      const SINGLE_ROUTES = [
        {
          match: () => has('template-page-collection') || path === '/pages/collecting-your-sample',
          buttons: [
            { label: 'Verify collection', href: k => `https://nmdcbbyi49i.typeform.com/to/Jvj8gQwa?kit_id=${encodeURIComponent(k)}` }
          ]
        },
        {
          match: () => path === '/pages/register-kit-step-1-complete',
          buttons: [
            { label: 'Submit and complete next step', href: k => `https://nmdcbbyi49i.typeform.com/to/GiAPIg7X?kit_id=${encodeURIComponent(k)}` }
          ]
        },
        {
          match: () => path === '/pages/register-kit-step-2-complete',
          buttons: [
            { label: 'Submit and complete next step', href: k => `/pages/collecting-your-sample?kit_id=${encodeURIComponent(k)}` }
          ]
        },
        {
          match: () => path === '/pages/vasectomy-step-1-completed',
          buttons: [
            { label: 'Submit and complete next step', href: k => `https://nmdcbbyi49i.typeform.com/to/inO7Jws8?kit_id=${encodeURIComponent(k)}` }
          ]
        }
      ];

      // tiny waiter
      const waitAll = (sel, tries=20, interval=150) => new Promise(res => {
        let n=0; (function poll(){ const nodes=[...document.querySelectorAll(sel)];
          if (nodes.length || n++>=tries) return res(nodes); setTimeout(poll, interval);
        })();
      });

      async function findTargetsByLabel(labelText) {
        const spans = await waitAll(`span.button__label[data-label="${labelText}"]`);
        return spans.map(s => s.closest('a,button,[role="button"]') || s).filter(Boolean);
      }

      for (const route of SINGLE_ROUTES) {
        if (!route.match()) continue;
        for (const btn of route.buttons) {
          const targets = await findTargetsByLabel(btn.label);
          if (!targets.length) { warn('No targets found for label', btn.label); continue; }
          const url = typeof btn.href === 'function' ? btn.href(kitId) : btn.href;
          if (!url) { warn('Invalid URL for', btn.label); continue; }
          targets.forEach(el => {
            el.setAttribute('data-kit-flow-href', url);
            setLinkAndShowEl(el, url);
          });
          log('Wired (single):', btn.label, '→', url, `(count=${targets.length})`);
        }
        break; // only first matching route
      }
    })();
  });
})();
